(function () {
  if (window.__bundleDiscountLoaded) return;
  window.__bundleDiscountLoaded = true;

  function getTriggerVariantIds() {
    var ids = new Set();
    document.querySelectorAll('[data-bundle-trigger-variants]').forEach(function (script) {
      try {
        JSON.parse(script.textContent).forEach(function (id) {
          ids.add(String(id));
        });
      } catch (error) {}
    });
    return ids;
  }

  function updateBundlePrices() {
    var priceBlocks = document.querySelectorAll('[data-bundle-price]');
    if (!priceBlocks.length) return;

    var triggerIds = getTriggerVariantIds();
    if (!triggerIds.size) return;

    fetch(`${window.routes.cart_url}.json`)
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var hasTrigger = cart.items.some(function (item) {
          return triggerIds.has(String(item.variant_id));
        });

        priceBlocks.forEach(function (block) {
          block.classList.toggle('price--bundle-active', hasTrigger);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', updateBundlePrices);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateBundlePrices);
  }
})();
